
<template>
  <!--社区app配置-->
  <x-application></x-application>
</template>

<script>
export default {
  name: 'communityApp',
  data () {
    return {};
  },
  mounted () {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/systemSet/communityApp/communityApp.vue